// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","SmartTextareaInput":"bgy_a bik_ve bik_vr bik_xh bik_vj"};